"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainGridView = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _gridView = require("../components/gridView");
var _useUISettings = require("../components/AppData/useUISettings");
var _useAppLayout = require("../components/AppData/useAppLayout");
var _constants = require("../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MainGridView = function MainGridView() {
  var centerRoles = (0, _useAppLayout.useAppLayout)("center") || [];
  var sidepaneRoles = (0, _useAppLayout.useAppLayout)("sidepane") || [];
  var maxTileCount = (0, _useUISettings.useUISettings)(_constants.UI_SETTINGS.maxTileCount);
  var peers = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeers);
  var localPeerId = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerID);
  var centerPeers = peers.filter(function (peer) {
    return centerRoles.includes(peer.roleName);
  });
  var sidebarPeers = peers.filter(function (peer) {
    return sidepaneRoles.includes(peer.roleName);
  });

  /**
   * If there are peers from many publishing roles, then it's possible to divide
   * them into two parts, those who show in center and those who show in sidepane.
   * In case there is only one person in the room, then too sidepane will be shown
   * and center would be taken up by a banner image.
   * There is an issue currently, where the banner is still shown if there are
   * multiple viewers in the room but no publisher. Depending on the use case
   * this can be useful(for webinar) or look odd(for showing you're the only one).
   * Note that both center peers and sidebar peers have only publishing peers in them.
   */
  var showSidePane = centerPeers.length > 0 && sidebarPeers.length > 0;
  if (centerPeers.length === 0) {
    // we'll show the sidepane for banner in this case too if 1). it's only me
    // in the room. or 2). noone is publishing in the room
    var itsOnlyMeInTheRoom = peers.length === 1 && peers[0].id === localPeerId;
    var nooneIsPublishing = sidebarPeers.length === 0;
    showSidePane = itsOnlyMeInTheRoom || nooneIsPublishing;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      size: "100%"
    },
    direction: {
      "@initial": "row",
      "@md": "column"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gridView.GridCenterView, {
      peers: showSidePane ? centerPeers : peers,
      maxTileCount: maxTileCount,
      allowRemoteMute: false,
      hideSidePane: !showSidePane,
      totalPeers: peers.length
    }), showSidePane && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gridView.GridSidePaneView, {
      peers: sidebarPeers,
      totalPeers: peers.length
    })]
  });
};
exports.MainGridView = MainGridView;